import createVueApp from '@phoenix/createVueApp';
import FullscreenVideoModal from '@maison/components/inTheMaking/FullscreenVideoModal.vue';

document.querySelectorAll('.phoenix-fullscreen-video-modal').forEach((el) => {
  const app = createVueApp({}, true);
  app.component('FullscreenVideoModal', FullscreenVideoModal);
  app.mount(el);
});
